import React, { ButtonHTMLAttributes } from 'react';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { TColorRole, TSize, colorMap } from '../../../types/types';
import { Loader } from '../../shared/Loader/Loader';
import IconLoader from '../../features/IconLoader/IconLoader';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';

interface IExecButtonProps {
    label: string;
    iconName: string;
    func?: () => void;
    isDisabled?: boolean;
    size?: TSize;
    iconSize?: number;
    textColor?: TColorRole;
    showIcon?: boolean;
    showLabel?: boolean;
    stretch?: boolean;
    centerText?: boolean;
    weight?: number;
    link?: boolean;
    gap?: number;
    isLoading?: boolean;
    btnType?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
    hasBorder?: boolean;
    hasBadge?: boolean;
    badgeValue?: number;
}

export const ExecButton: React.FC<IExecButtonProps> = ({
    showIcon = true,
    showLabel = true,
    textColor = 'dark',
    label,
    iconName,
    func,
    isDisabled = false,
    size = 'm',
    iconSize = 2,
    stretch = false,
    centerText = false,
    weight = 700,
    link = false,
    isLoading = false,
    btnType = 'button',
    hasBorder = true,
    hasBadge = false,
    badgeValue = 0,
}) => {
    const hexColor = colorMap[textColor] || colorMap['dark'];

    return (
        <button
            type={btnType}
            style={{
                fontWeight: `${weight}`,
                position:'relative'
            }}
            className={`
                ${link && 'execButton__link'}
                execButton
                ${centerText && 'execButton__center'}
                ${stretch && 'execButton__stretch'}
                execButton__${size}
                ${link && `execButton__${size}--link`}
                execButton__${isDisabled ? 'disabled' : 'enabled'}
                ${link && 'execButton__enabled--link'}
                ${hasBorder && 'execButton__enabled--border'}
                `}
            disabled={isDisabled}
            onClick={func}
        >
            {/* BADGE */}
            {
                hasBadge && badgeValue > 0
                &&
                <div className='animation-zoom-5' style={{overflow:'hidden', width:'16px', height:'16px' ,backgroundColor:'#bc0f23', position:'absolute', top:'-8px', right:'-8px', borderRadius:'20%', color:'white', display:'flex', justifyContent:'center', alignItems:'center', fontWeight:'400', fontSize:'1rem'}}>
                    <div style={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                        {badgeValue}
                    </div>
                </div>
            }
                {showIcon && isLoading 
                ? 
                <Loader hasText={false} width={20} height={20} color="grey-dark" />
                : 
                <IconComponent size={iconSize} iconName={`${!isDisabled ? iconName : iconName + '_disabled'}`} />
                }
                {showLabel && <div style={{ color: `${!isDisabled ? hexColor : colorMap['grey-normal']}` }}>{label}</div>}
        </button>
    );
};
